<template>
  <div class="word-cloud"></div>
</template>

<script>
import cloud from 'd3-cloud';

  export default {
    name: 'word-cloud',
    props: ['data', 'width', 'height', 'keyField', 'valueField'],

    mounted () {
      this.render();
    },
    methods: {
      render () {
        var self = this;

        var minValue = d3.min(self.data, function(d) {
          return +d[self.valueField];
        });
        var maxRow = self.data.reduce(function(a, b) {
          return +a[self.valueField] > +b[self.valueField] ? a : b;
        });

        var fontSizeScale = d3.scale.linear()
          .domain([minValue, +maxRow[self.valueField]])
          .range([24, 70]);

        var layout = cloud()
            .size([self.width, self.height])
            .words(self.data.map(function(d) {
              return {
                text: d[self.keyField],
                size: fontSizeScale(+d[self.valueField])
              };
            }))
            .padding(5)
            .rotate(function() { return 0; })
            .font("Impact")
            .fontSize(function(d) { return d.size; })
            .on("end", function(words) {
              d3.select(self.$el)
                .append("svg")
                  .attr("width", layout.size()[0])
                  .attr("height", layout.size()[1])
                .append("g")
                  .attr("transform", "translate(" + layout.size()[0] / 2 + "," + layout.size()[1] / 2 + ")")
                .selectAll("text")
                  .data(words)
                .enter().append("text")
                  .style("font-size", function(d) { return d.size + "px"; })
                  .style("font-family", "Impact")
                  .style("fill", "rgb(108, 120, 131)")
                  .classed('word-cloud-selected', function(d) { return d.text === maxRow["name"]; })
                  .attr("text-anchor", "middle")
                  .attr("transform", function(d) {
                    return "translate(" + [d.x, d.y] + ")";
                  })
                  .text(function(d) { return d.text.toLowerCase(); })
                  .on("click", function(d) {
                    var previousWordElem = d3.select(".word-cloud .word-cloud-selected");

                    previousWordElem.classed('word-cloud-selected', false);
                    d3.select(this).classed('word-cloud-selected', true);

                    var previousWord = previousWordElem.data()[0].text;
                    self.onWordClick(d.text, previousWord);
                  });
            });

        layout.start();
        self.onWordClick(maxRow["name"], null);
      },

      onWordClick (newWord, previousWord) {
        var self = this;
        self.$emit('clicked', newWord, previousWord);
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
text.word-cloud-selected {
  fill: rgb(169, 221, 183) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/WordCloud.vue